import { rgba } from 'polished';

import * as Colors from './colors';

export const SHADOW_10 = `0 0 0 1px ${rgba(Colors.BLACK, 0.03)}`;
export const SHADOW_20 = `0 2px 4px ${rgba(Colors.BLACK, 0.03)}`;
export const SHADOW_30 = `0 5px 10px ${rgba(Colors.BLACK, 0.03)}`;
export const SHADOW_40 = `0 20px 40px ${rgba(Colors.BLACK, 0.03)}`;

export const SHADOW_EQ_10 = `0 0 1px ${rgba(Colors.BLACK, 0.05)}`;
export const SHADOW_EQ_20 = `0 0 4px ${rgba(Colors.BLACK, 0.05)}`;
export const SHADOW_EQ_30 = `0 0 8px ${rgba(Colors.BLACK, 0.05)}`;
export const SHADOW_EQ_40 = `0 0 16px ${rgba(Colors.BLACK, 0.1)}`;
